import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../../style.css';

function Jovenes() {
  const details = [
    { icon: '📖', label: 'Libro', value: 'Time Zones' },
    { icon: '🕮', label: 'Editorial', value: 'National Geographic' },
    { icon: '⌛', label: 'Horas por semana', value: '5.5 hrs. (4.5 hrs clase + 1 hr club conversación)' },
    { icon: '📆', label: 'Duración del nivel', value: '15 semanas' },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Inglés para Jóvenes | Culturlingua</title>
        <meta name="description" content="11 a 15 años · Enfocado en autonomía y práctica" />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Inglés · Culturlingua</div>
        <h1>Inglés para Jóvenes</h1>
        <p>11 a 15 años · Enfocado en autonomía y práctica</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'900px', margin:'0 auto'}}>

          <div style={{background:'white', borderRadius:'20px', padding:'40px', boxShadow:'0 2px 16px rgba(0,0,0,0.06)', marginBottom:'32px'}}>
            <div className="section-tag">Acerca del curso</div>
            <h2 className="section-headline" style={{fontSize:'1.6rem', marginBottom:'16px'}}>Inglés para Jóvenes</h2>
            <p style={{color:'var(--muted)', lineHeight:'1.8'}}>Curso de inglés para estudiantes de secundaria que ayuda a ser más autónomos. Introducimos, reforzamos y perfeccionamos su conocimiento del lenguaje en un contexto adecuado a su edad, utilizando un enfoque ecléctico comunicativo en un ambiente casual, práctico y divertido.</p>
          </div>

          <div style={{display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:'16px', marginBottom:'40px'}}>
            {details.filter(d => d.value !== 'N/A').map((d) => (
              <div key={d.label} style={{background:'white', borderRadius:'14px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', display:'flex', alignItems:'flex-start', gap:'14px'}}>
                <div style={{fontSize:'1.6rem'}}>{d.icon}</div>
                <div>
                  <div style={{fontSize:'0.75rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:'0.5px', fontWeight:'600', marginBottom:'4px'}}>{d.label}</div>
                  <div style={{fontWeight:'600', color:'var(--navy)'}}>{d.value}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'40px', textAlign:'center'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.6rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿Listo para empezar?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'28px'}}>Sin compromisos. Te contactamos para orientarte.</p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/contacto" className="btn-glow">Inscribirme →</Link>
              <Link to="/Examen-de-ubicacion" className="btn-outline">Examen de Ubicación</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Jovenes;
